module.exports = __webpack_public_path__ + "images/translate-image-0d3afd3fd20f91985ed77952bed6dbb1.png";